export default "__VITE_ASSET__B05Dq03z__"